<template>
  <div class="container-activity-detail">
    <MpNavbar />
    <MpTitle
      v-if="activityData"
      :title="'风味汇总表：' + activityData.title"
      :intro="
        '杯测表：' +
        activityData.table.name +
        ' | 本次杯测共' +
        activityData.tableData.length +
        '个咖啡豆 | ' +
        (activityData.desc || '无活动介绍')
      "
    />
    <div class="content-table" id="content-table">
      <vxe-toolbar>
        <template #buttons>
          <vxe-button @click="reflash">刷新</vxe-button>
          <vxe-button @click="exportDataEvent">导出.xlsx表格</vxe-button>
          <vxe-button @click="printEvent">打印</vxe-button>
        </template>
      </vxe-toolbar>
      <vxe-grid ref="xTable" v-bind="gridOptions"></vxe-grid>
    </div>
  </div>
</template>

<script>
import MpNavbar from "../../components/mp/navbar";
import MpTitle from "../../components/mp/title";
import { apiActivityDetail } from "../../request/api";

export default {
  components: {
    MpNavbar,
    MpTitle,
  },
  name: "activityDetail",
  data() {
    return {
      uuid: null,
      activityData: null,
      gridOptions: {
        border: true,
        height: null,
        loading: false,
        highlightCurrentRow: true,
        rowClassName: this.rowClassName,
        cellClassName: this.cellClassName,
        align: "left",
        mergeCells: null,
        columns: null,
        data: null,
      },
    };
  },
  mounted() {
    this.init();
    window.onresize = () => {
      this.setTableHeight();
    };
  },
  methods: {
    init() {
      this.uuid = this.$route.params.uuid;
      this.getDetail();
      this.setTableHeight();
    },
    setTableHeight() {
      var h = document.body.clientHeight - 50 - 69 - 60;
      this.gridOptions.height = h;
    },
    reflash() {
      this.gridOptions.mergeCells = null;
      this.gridOptions.columns = null;
      this.gridOptions.data = null;
      this.getDetail();
    },
    getDetail() {
      this.gridOptions.loading = true;
      let self = this;
      apiActivityDetail({
        uuid: self.uuid,
      })
        .then((res) => {
          self.activityData = res.data;
          self.readyData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    readyData(resData) {
      let data = resData.tableData;
      let dataA = [];
      for (let index = 0; index < data.length; index++) {
        let obj = data[index];
        obj.beanInfo = data[index].beanInfo;
        obj.beanUuid = data[index].beanUuid;
        obj.beanIndex = index;
        // 用户测评数据初始化
        obj.userNickName = "";
        obj.completed = 0;
        obj.fav = 0;
        obj.score = 0;
        obj.remarks = "";
        obj.mergeValue = null;
        // 合并用户测评数据
        let uerNumber = data[index].users.length;
        obj.uerNumber = uerNumber;
        for (let index2 = 0; index2 < uerNumber; index2++) {
          let obj2 = obj.users[index2];
          // 杯测人
          obj.userNickName = obj.userNickName + obj2.userInfo.nickname + "；";
          if (index2 == uerNumber - 1 && obj.userNickName) {
            //汇总结束-数据处理
            obj.userNickName = this.mergeText(obj.userNickName);
          }
          // 完成人数
          if (obj2.status == 3) {
            obj.completed++;
          }
          // 收藏人数
          if (obj2.fav == 2) {
            obj.fav++;
          }
          // 总分
          obj.score = obj.score + obj2.score;
          if (index2 == uerNumber - 1 && obj.score) {
            // 汇总结束-求平均值
            obj.score = this.mergeScore(obj.score, uerNumber);
          }
          // 备注
          if (obj2.remarks) {
            obj.remarks = obj.remarks + obj2.remarks + "；";
          }
          if (index2 == uerNumber - 1 && obj.remarks) {
            //汇总结束-数据处理
            obj.remarks = this.mergeText(obj.remarks);
          }
          // 重点 - 杯测结果数据
          if (obj2.data && obj2.data.length > 0) {
            let tempValue = [];
            let valueNumber = obj2.data.length;
            if (!obj.mergeValue) {
              // 第一个人，直接输入数据
              obj.mergeValue = obj2.data;
            } else {
              // 第二个人起，开始合并数据
              for (let index3 = 0; index3 < valueNumber; index3++) {
                let obj3 = obj2.data[index3];
                //  分数  ********
                if (obj3.value.score) {
                  obj.mergeValue[index3].value.score =
                    obj.mergeValue[index3].value.score + obj3.value.score;
                }
                if (
                  index2 == uerNumber - 1 &&
                  obj.mergeValue[index3].value.score
                ) {
                  // 汇总结束-求平均值
                  obj.mergeValue[index3].value.score = this.mergeScore(
                    obj.mergeValue[index3].value.score,
                    uerNumber
                  );
                }
                //  描述  ********
                if (obj3.value.desc) {
                  let word = obj.mergeValue[index3].value.desc
                    ? obj.mergeValue[index3].value.desc + "；"
                    : "";
                  obj.mergeValue[index3].value.desc = this.mergeText(
                    word + obj3.value.desc
                  );
                }
                if (
                  index2 == uerNumber - 1 &&
                  obj.mergeValue[index3].value.desc
                ) {
                  //汇总结束-数据处理
                  obj.mergeValue[index3].value.desc = this.mergeText(
                    obj.mergeValue[index3].value.desc
                  );
                }
                // 正负面评价组件 - 正面  ********
                if (obj3.value.positive) {
                  let word = obj.mergeValue[index3].value.positive
                    ? obj.mergeValue[index3].value.positive + "；"
                    : "";
                  obj.mergeValue[index3].value.positive =
                    word + obj3.value.positive + "；";
                }
                if (
                  index2 == uerNumber - 1 &&
                  obj.mergeValue[index3].value.positive
                ) {
                  //汇总结束-数据处理
                  obj.mergeValue[index3].value.positive = this.mergeText(
                    obj.mergeValue[index3].value.positive
                  );
                }
                // 正负面评价组件 - 负面  ********
                if (obj3.value.negative) {
                  let word = obj.mergeValue[index3].value.negative
                    ? obj.mergeValue[index3].value.negative + "；"
                    : "";
                  obj.mergeValue[index3].value.negative =
                    word + obj3.value.negative + "；";
                }
                if (
                  index2 == uerNumber - 1 &&
                  obj.mergeValue[index3].value.negative
                ) {
                  //汇总结束-数据处理
                  obj.mergeValue[index3].value.negative = this.mergeText(
                    obj.mergeValue[index3].value.negative
                  );
                }
                // 瑕疵记录组件 - 杯数平均值  ********
                if (obj3.value.cups) {
                  obj.mergeValue[index3].value.cups =
                    obj.mergeValue[index3].value.cups + obj3.value.cups;
                }
                if (
                  index2 == uerNumber - 1 &&
                  obj.mergeValue[index3].value.cups
                ) {
                  // 汇总结束-求平均值
                  obj.mergeValue[index3].value.cups = this.mergeScore(
                    obj.mergeValue[index3].value.cups,
                    uerNumber
                  );
                }
                // 瑕疵记录组件 - 严重程度平均值  ********
                if (obj3.value.intensity) {
                  obj.mergeValue[index3].value.intensity =
                    obj.mergeValue[index3].value.intensity +
                    obj3.value.intensity;
                }
                if (
                  index2 == uerNumber - 1 &&
                  obj.mergeValue[index3].value.intensity
                ) {
                  // 汇总结束-求平均值
                  obj.mergeValue[index3].value.intensity = this.mergeScore(
                    obj.mergeValue[index3].value.intensity,
                    uerNumber
                  );
                }
                //小型单选组件 - 选项  ********
                if (obj3.value.select) {
                  // 判断是否为数组
                  if (obj3.value.select instanceof Array) {
                    obj3.value.select = obj3.value.select.join("；");
                  } else {
                    obj3.value.select = obj3.value.select;
                  }
                  let word = obj.mergeValue[index3].value.select
                    ? obj.mergeValue[index3].value.select + "；"
                    : "";
                  obj.mergeValue[index3].value.select =
                    word + obj3.value.select + "；";
                }
                if (
                  index2 == uerNumber - 1 &&
                  obj.mergeValue[index3].value.select
                ) {
                  //汇总结束-数据处理
                  obj.mergeValue[index3].value.select = this.mergeSelect(
                    obj.mergeValue[index3].value.select
                  );
                }
              }
            }
          }
        }
        dataA.push(obj);
      }
      // 结果数据计算完成
      this.gridOptions.data = dataA;

      // 3-整合数据列标题
      //获取table杯测表基础数据
      let columnsA = [
        { type: "seq", width: 50 },
        { field: "beanInfo.name", title: "咖啡豆", width: 100 },
        { field: "userNickName", title: "杯测人", width: 100 },
        { field: "completed", title: "确认提交人数", width: 70 },
        { field: "fav", title: "收藏人数", width: 50 },
        { field: "score", title: "总分(平均分)", align: "center", width: 80 },
      ];
      let columnsB = [];
      let columnsC = [{ field: "remarks", title: "备注", width: 200 }];
      let tableForm = resData.table.form;
      // 计算列
      for (let index = 0; index < tableForm.length; index++) {
        let type = tableForm[index].type;
        let ary;
        if (type == "p_n") {
          // 组件 - 正负面评价
          ary = [
            {
              field: "mergeValue." + index + "." + "value.positive",
              title: tableForm[index].name + "(正面)",
              width: 100,
            },
            {
              field: "mergeValue." + index + "." + "value.negative",
              title: tableForm[index].name + "(负面)",
              width: 100,
            },
          ];
        } else if (
          type == "scroll_desc" ||
          type == "scroll_array_desc" ||
          type == "select_score_desc"
        ) {
          // 组件 - 滑块和描述
          ary = [
            {
              field: "mergeValue." + index + "." + "value.score",
              title: tableForm[index].name + "(平均分)",
              width: 100,
              align: "right",
            },
            {
              field: "mergeValue." + index + "." + "value.desc",
              title: tableForm[index].name + "(描述)",
              width: 100,
            },
          ];
        } else if (type == "unicup_desc") {
          // 组件 - 一致性评测组件
          ary = [
            {
              field: "mergeValue." + index + "." + "value.cups",
              title: tableForm[index].name + "(平均分)",
              width: 90,
              formatter: this.formatUnicup,
            },
            {
              field: "mergeValue." + index + "." + "value.desc",
              title: tableForm[index].name + "(描述)",
              width: 100,
            },
          ];
        } else if (type == "boolean_desc") {
          // 选择Yes/No组件
          ary = [
            {
              field: "mergeValue." + index + "." + "value.boolean",
              title: tableForm[index].name + "(平均分)",
              width: 100,
            },
            {
              field: "mergeValue." + index + "." + "value.desc",
              title: tableForm[index].name + "(描述)",
              width: 100,
            },
          ];
        } else if (type == "defects_desc") {
          // 组件 - 瑕疵记录组件
          ary = [
            {
              field: "mergeValue." + index + "." + "value.cups",
              title: tableForm[index].name + "(平均杯数)",
              width: 100,
            },
            {
              field: "mergeValue." + index + "." + "value.intensity",
              title: tableForm[index].name + "(平均严重程度)",
              width: 100,
            },
            {
              field: "mergeValue." + index + "." + "value.desc",
              title: tableForm[index].name + "(描述)",
              width: 100,
            },
          ];
        } else if (type == "select_lite_desc") {
          // 组件 - 小型单选组件
          ary = [
            {
              field: "mergeValue." + index + "." + "value.select",
              title: tableForm[index].name,
              width: 100,
            },
            {
              field: "mergeValue." + index + "." + "value.desc",
              title: tableForm[index].name + "(描述)",
              width: 100,
            },
          ];
        } else if (type == "desc") {
          // 组件 - 单文本输入组件
          ary = [
            {
              field: "mergeValue." + index + "." + "value.desc",
              title: tableForm[index].name,
              width: 100,
            },
          ];
        } else if (type == "min_title") {
          // 组件 - 分隔小标题
          ary = [];
        } else if (type == "select_score_select_multiple") {
          // 组件 - 多选组件
          ary = [
            {
              field: "mergeValue." + index + "." + "value.select",
              title: tableForm[index].name,
              width: 100,
            },
            {
              field: "mergeValue." + index + "." + "value.select",
              title: tableForm[index].name + "(选择)",
              width: 100,
            },
          ];
        } else if (type == "select_multiple") {
          // 组件 - 多选组件
          ary = [
            {
              field: "mergeValue." + index + "." + "value.select",
              title: tableForm[index].name + "(选择)",
              width: 100,
            },
          ];
        } else {
          // 未知组件
          ary = [];
        }
        columnsB = [...columnsB, ...ary];
      }

      this.gridOptions.columns = [...columnsA, ...columnsB, ...columnsC];

      // 转置数据和列
      const transposed = this.transposeData(
        this.gridOptions.data,
        this.gridOptions.columns
      );
      this.gridOptions.data = transposed.data;
      this.gridOptions.columns = transposed.columns;

      this.gridOptions.loading = false;
    },
    // 获取嵌套属性值的辅助函数
    getNestedValue(obj, path) {
      if (!path) return undefined; // 如果路径为空，返回undefined
      return path.split(".").reduce((o, p) => (o ? o[p] : undefined), obj);
    },
    // 转置数据和列的方法
    transposeData(data, columns) {
      let newColumns = [{ field: "fieldName", title: "评测项", width: 150 }];
      for (let i = 0; i < data.length; i++) {
        newColumns.push({
          field: "value" + i,
          title: data[i].beanInfo.name || "样品 " + (i + 1),
          width: 100,
        });
      }

      let newData = [];

      for (let j = 0; j < columns.length; j++) {
        const field = columns[j].field;
        // 跳过没有 field 的列，例如 type 为 'seq' 的列
        if (!field) continue;
        const row = { fieldName: columns[j].title };
        for (let i = 0; i < data.length; i++) {
          row["value" + i] = this.getNestedValue(data[i], field);
        }
        newData.push(row);
      }

      return { data: newData, columns: newColumns };
    },
    formatFav({ cellValue, row, column }) {
      if (cellValue == 2) {
        return "★";
      } else {
        return "";
      }
    },
    formatStatus({ cellValue, row, column }) {
      if (cellValue == 3) {
        return "已提交";
      } else {
        return "未提交";
      }
    },
    formatUnicup({ cellValue, row, column }) {
      if (cellValue) {
        let result = "";
        for (let index = 0; index < cellValue.length; index++) {
          if (cellValue[index] == 1) {
            result = result + "×";
          } else {
            result = result + "□";
          }
        }
        return result;
      } else {
        return "";
      }
    },
    formatScore({ cellValue, row, column }) {
      if (cellValue == 0) {
        return "无分数";
      } else {
        return cellValue;
      }
    },
    mergeScore(value, number) {
      return (value / number).toFixed(2);
    },
    mergeText(value) {
      if (!value) return ""; // 如果 value 为空，返回空字符串，避免后续报错
      // 提取字符串中的英文和数字为字符串
      let reg = /[\u4e00-\u9fa5]/g;
      let english = value.replace(reg, ",");
      let englishArray = [];
      if (english && english.length > 0) {
        englishArray = english.split(/,|;|，|；/);
        englishArray = englishArray.map((item) => item.trim());
        englishArray = englishArray.filter((item) => item != "\r");
        englishArray = englishArray.filter((item) => item);
        englishArray = [...new Set(englishArray)];
      }
      // 提取字符串中的中文为字符串
      let reg2 = /[a-zA-Z0-9]/g;
      let chinese = value.replace(reg2, ",");
      let chineseArray = [];
      if (chinese && chinese.length > 0) {
        chineseArray = chinese.split(/,| |;|，|；|\s+/);
        chineseArray = chineseArray.filter((item) => item != ".");
        chineseArray = chineseArray.filter((item) => item != "\r");
        chineseArray = chineseArray.filter((item) => item);
        chineseArray = [...new Set(chineseArray)];
      }
      // 合并英文和中文数组
      let result = [...englishArray, ...chineseArray];
      result = result.join("，");
      return result;
    },
    mergeSelect(value) {
      if (value) {
        return value.slice(0, -1);
      } else {
        return "";
      }
    },
    exportDataEvent() {
      let self = this;
      this.$refs.xTable.exportData({
        filename: "【风味汇总表】" + self.activityData.title,
        sheetName: "Sheet1",
        type: "xlsx",
      });
    },
    rowClassName({ row, rowIndex }) {
      if (rowIndex === 0) {
        // 第一行，咖啡豆行
        return "first-row-gray";
      }
      // 表格正文部分底色为白色，不需要特殊处理
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      // 根据需要可以添加其他 cell 的样式处理
    },
    printEvent() {
      this.$refs.xTable.print({
        sheetName: this.activityData.title + "- GiiLoo 咖啡杯测",
      });
    },
  },
};
</script>

<style scoped>
.container-activity-detail {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  padding-left: 110px;
  padding-top: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
}

.content-table {
  flex: 1;
  height: 200px;
  margin: 0;
}
</style>
<style>
/* 第一行灰色背景 */
.first-row-gray .vxe-body--row {
  background-color: #f0f0f0 !important;
}

/* 表格正文部分底色为白色 */
.vxe-table--body .vxe-body--row {
  background-color: #ffffff;
}

/* 其他样式 */
.min_title {
  font-weight: bold;
}

.activity-detail-cell-red {
  color: #fd4343;
}

.activity-detail-cell-fav {
  font-size: 20px;
  color: #ffd685;
}

.activity-detail-cell-bold {
  font-size: 18px;
  font-weight: bold;
}

.activity-detail-cell-gray {
  color: #ccc;
}
</style>
